import React,{Component} from 'react'

import {
  Avatar,
  Chip,
} from 'material-ui'

import {Link} from 'react-router-dom'

export default class UserChip extends Component{
  constructor(props){
    super(props);
    this.state = {};
  }

  click=()=>{
    // this.props.history.push(`/User/${this.props.user.uid}`)
  }
  render(){
    console.log(this.props);
    const {user} = this.props;
    return(
      <Link to={`/User/${user.uid}`}>
        <Chip
          avatar=
            {!!user.photoURL && <Avatar
              aria-label={user.photoURL && user.displayName ? user.displayName : null}
              src={user.photoURL ? user.photoURL : null}
              >
                {user.photoURL?null:user.displayName?user.displayName[0]:null}
              </Avatar>
            }
          label={user.displayName?user.displayName:user.email?user.email:user.uid}
          onClick={this.click}
        />
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/UserChip.js